export default __webpack_public_path__ + "static/media/06c31d68e3b8dba38d74b4fab73950b1.svg";